import { useEffect, useState } from 'react';

import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from '@lingui/react/macro';
import { Button } from '@repo/videa-components/src/index';
import classNames from 'classnames';

import {
  usePreferences,
  usePreferencesUserUpdate,
} from '@/react-query/usePreferences';
import { mixpanelEvents, useTrackEvent } from '@/utils/mixpanel';

export const ViewerRedesignButton = () => {
  const [isSaving, setIsSaving] = useState(false);

  const { data: prefs } = usePreferences();
  const { mutateAsync: updateUserPreferences } = usePreferencesUserUpdate();
  const { trackEvent } = useTrackEvent();

  const handleClick = async () => {
    setIsSaving(true);

    const isSwitchingToRedesign = !prefs.useSidebarRedesign;
    trackEvent(mixpanelEvents.imageViewerRedesignToggle, {
      isSwitchingToRedesign,
    });
    await updateUserPreferences({ useSidebarRedesign: isSwitchingToRedesign });
    // Give access to patient view by default preference when switching to new viewer
    if (isSwitchingToRedesign) {
      await updateUserPreferences({
        saveSegmentationViewEnabled: true,
      });
    }
    // Turn patient view by default off when switching to old viewer and on when switching to new viewer
    await updateUserPreferences({
      showSegmentationView: isSwitchingToRedesign,
    });

    setIsSaving(false);
  };

  if (!prefs.canOptInImageViewerRedesign) {
    return null;
  }

  return (
    <div
      className={classNames('vai-my-2', {
        'vai-mx-8': !prefs.useSidebarRedesign,
        'vai-mx-6': prefs.useSidebarRedesign,
      })}
    >
      <Button
        className={classNames('vai-w-full !vai-p-[1px] !vai-overflow-hidden', {
          'vai-bg-gradient-to-r vai-from-[rgba(255,222,89,1)] vai-to-[rgba(89,169,255,1)] hover:vai-from-[rgba(255,222,89,0.7)] hover:vai-to-[rgba(89,169,255,0.7)]':
            !prefs.useSidebarRedesign,
          'vai-bg-[#59A9FF] new-annotator': prefs.useSidebarRedesign,
        })}
        disabled={isSaving}
        onClick={handleClick}
        data-testid="viewer-redesign-button"
      >
        <div className="vai-bg-gradient-to-b vai-from-[#1D212A] vai-to-[#2D3341] vai-w-full vai-h-full vai-flex vai-items-center vai-justify-center vai-px-6 vai-rounded-[5px]">
          {isSaving ? (
            <div className="vai-h-5 vai-w-5 vai-border-2 vai-border-slate-200 vai-border-t-transparent vai-rounded-full vai-animate-spin"></div>
          ) : (
            <p className="vai-font-inter vai-text-[16px] vai-font-medium">
              {prefs.useSidebarRedesign ? (
                <Trans>Back to Old AI Viewer</Trans>
              ) : (
                <Trans>Try the New AI Viewer (Beta)</Trans>
              )}
            </p>
          )}
        </div>
      </Button>
    </div>
  );
};
